module.exports = __webpack_public_path__ + "static/media/illustration-section-06.ca088d9d.svg";